import { useSelector } from "react-redux";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import ListContainer from "../../../_utils/CommonListView/ListContainer";
import CommonBankLogo from "../../../_utils/CommonBankLogo";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import TickerAnimation from "../../../_utils/TickerAnimation";
import CardActionableButton from "../../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import ListTextWithIcon from "../../../_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import ListTextWithGif from "../../../_utils/CommonListView/ListSubComponent/ListTextWithGif";
import ListDualText from "../../../_utils/CommonListView/ListSubComponent/ListDualText";
import { useLocation } from "react-router-dom";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import ICONS from "../../../../assets/Icons";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import TEXT from "../../../../utils/globalText.js";

const OwnerAccountListViewComp = ({
  index,
  item,
  handleRefresh,
  isopen,
  setRefreshtype,
  setFailedRefreshId,
  failedRefreshId,
  successRefreshId,
  setSuccessRefreshId,
  currency,
  setPrev_Total_balance_state,
  total_balance,
  refreshAll,
  typepop,
  txnPayLoad,
  setTxnPayLoad,
  handleButtonClick,
  setOpenOwner,
  flow,
  handleViewStatement,
  ownerAccBalanceLoading,
  navigate,
  accId,
  setAccId,
  setStatementId,
  setAccData,
  prevId,
  setPrevId,
  prevBalance,
  setPrevBalance,
  multiSelect,
  isAssignTagsClicked,
  owneraccountnumberstate,
  setowneraccountnumberstate,
  isLabelClicked,
  handleOwnerAccountSelect,
  TypeRTGS,
  currentAccountDetails,
  filterRef,
}) => {
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };

  const location = useLocation();
  const services = useSelector((state) => state.refreshToken.services);
  const service =
    services?.includes("VAccountBalance") || services?.includes("Admin");
  const isAccountSelected = owneraccountnumberstate?.some
    ? owneraccountnumberstate.some((selectedAccount) =>
        typeof selectedAccount === "object"
          ? selectedAccount?.id === item?.id
          : selectedAccount === item?.id,
      )
    : false;

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const isFailedRefresh = failedRefreshId?.includes(item?.id);
  const isSuccessRefresh = successRefreshId?.includes(item?.id);

  const getRefreshGifProps = () => {
    if (isFailedRefresh) {
      return {
        type: "text",
        text: "Currently unable to fetch balance details. Please try again later.",
        icon: ICONS?.ERROR_WITH_ORANGE_CIRCLE,
        subtext: "Error",
      };
    }

    if (isSuccessRefresh) {
      const isIncreased = item?.increaseOrDecrease === "increased";
      const isDecreased = item?.increaseOrDecrease === "decreased";

      return {
        type: "Amount",
        bgColor: isIncreased
          ? "var(--positive-bg)"
          : isDecreased
            ? "var(--negative-bg)"
            : "inherit",
        text: item?.difference,
        icon: isIncreased
          ? ICONS?.ARROW_UP_GREEN_GIF
          : isDecreased
            ? ICONS?.ARROW_DOWN_RED_GIF
            : null,
        subtext: `Balance ${
          item?.increaseOrDecrease === ""
            ? "increased"
            : item?.increaseOrDecrease
        } by `,
      };
    }

    return null;
  };

  const refreshGifProps = getRefreshGifProps();

  return (
    <ListContainer
      key={item?.id ?? index}
      hoverHeight={
        isSuccessRefresh || isFailedRefresh
          ? GlobalConfiguration.ownerAccountListHoverHeightWithRefresh
          : GlobalConfiguration.ownerAccountListHoverHeightWithoutRefresh
      }
      filterRef={filterRef}
      isSelected={
        (multiSelect || isAssignTagsClicked || isLabelClicked) &&
        isAccountSelected
      }
      isDisabled={
        (typepop === "popup" &&
          item?.connected_banking === "N" &&
          flow !== "internalTxn") ||
        isopen ||
        (item?.pan_no === txnPayLoad?.pan &&
          item?.bank_acc_no === txnPayLoad?.bankAccountNo &&
          item?.ifsc_code === txnPayLoad?.bankAccountIFSC &&
          flow === "createTxn")
      }
      context={item}
      onClickHandler={async (e) => {
        if (isAssignTagsClicked || isLabelClicked) {
          e.stopPropagation();

          if (handleOwnerAccountSelect) {
            handleOwnerAccountSelect(item);
          } else if (owneraccountnumberstate?.includes(item?.id)) {
            setowneraccountnumberstate(() => {
              return owneraccountnumberstate?.filter((acc) => acc !== item?.id);
            });
          } else {
            if (
              owneraccountnumberstate.length >=
              PaginationConfiguration.paginationBig
            )
              return;
            setowneraccountnumberstate([...owneraccountnumberstate, item?.id]);
          }
        } else if (typepop === "popup") {
          if (multiSelect) {
            e.stopPropagation();
            handleOwnerAccountSelect(item);
          } else if (flow === "createTxn") {
            setTxnPayLoad({
              ...txnPayLoad,
              ownerId: item?.id,
              ownerBankIFSC: item?.ifsc_code,
              ownerBankBalance: item?.owner_account_balance,
              ownerBankLogo: item?.bank_name,
              ownerLastUpdated:
                item?.owner_account_balance_last_fetched_at_in_words,
              ownerBankAccountNo: item?.bank_acc_no,
              ownerBankAccountName: item?.bank_account_holder_full_name,
              ownerPan: item?.pan_no,
              settleType:
                TypeRTGS === "RequestRTGS"
                  ? Number(currentAccountDetails?.amount) >
                    Number(GlobalConfiguration?.settleTypeValue)
                    ? "rtgs"
                    : "neft"
                  : "neft",
              ownerLabels: [...(item?.labels || [])],
            });
          } else if (flow === "internalTxnSource") {
            setTxnPayLoad({
              ...txnPayLoad,
              ownerId: item?.id,
              ownerBankIFSC: item?.ifsc_code,
              ownerBankBalance: item?.owner_account_balance,
              ownerBankLogo: item?.bank_name,
              ownerLastUpdated:
                item?.owner_account_balance_last_fetched_at_in_words,
              ownerBankAccountNo: item?.bank_acc_no,
              ownerBankAccountName: item?.bank_account_holder_full_name,
              ownerPan: item?.pan_no,
              settleType: "neft",
              ownerlabels: [...(item?.labels || [])],
            });
          } else if (flow === "ReimbursementRequestMultiFlow") {
            handleButtonClick(item);
          } else if (flow === "txnViewAll") {
            if (e && e.stopPropagation) {
              e.stopPropagation();
            }
            handleButtonClick(item);
          }

          if (!multiSelect) {
            setOpenOwner(false);
          }
        } else {
          let selection = window.getSelection();
          if (!selection.toString().length) {
            if (!isopen) {
              navigate(
                `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${item?.id}`,
                {
                  state: {
                    isViewAll:
                      location.pathname ===
                      "/owner_account_dashboard/owner_accounts_view_all",
                  },
                },
              );
            }
          }
        }
      }}
    >
      <list-body>
        <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
          <div className="flex flex-col gap-y-gap-sm w-full">
            <div className="w-full flex Qxs:gap-x-gap-sm gap-x-gap-xs">
              <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                <CommonBankLogo
                  variant="small"
                  ifsc={item?.ifsc_code}
                />
              </div>
              <p className="text-text-primary text-font-xs min-w-standard-account-min-width flex-0 flex font-normal">
                {standardAccountNumberFormat(item?.bank_acc_no)}
              </p>
              <div className="border-l border-primary-bg"></div>
              <div className="flex gap-x-gap-xs justify-end items-center flex-1">
                {ownerAccBalanceLoading && accId === item?.id ? (
                  <img
                    className="w-icon-sm h-icon-sm"
                    src={ICONS?.LOADER_GIF}
                    alt=""
                  />
                ) : isFailedRefresh ? (
                  <img
                    className="w-icon-sm h-icon-sm"
                    src={ICONS?.ERROR_WITH_ORANGE_CIRCLE}
                    alt=""
                  />
                ) : !ownerAccBalanceLoading &&
                  item?.id === prevId &&
                  prevBalance !== undefined &&
                  Number(item?.owner_account_balance) !==
                    Number(prevBalance) ? (
                  Number(item?.owner_account_balance) > Number(prevBalance) ? (
                    <img
                      className="w-icon-sm h-icon-sm"
                      src={ICONS?.ARROW_UP_GREEN_GIF}
                      alt=""
                    />
                  ) : Number(item?.owner_account_balance) <
                    Number(prevBalance) ? (
                    <img
                      className="w-icon-sm h-icon-sm"
                      src={ICONS?.ARROW_DOWN_RED_GIF}
                      alt=""
                    />
                  ) : null
                ) : null}

                <p
                  className={`text-font-xs ${
                    item?.owner_account_balance
                      ? item?.owner_account_balance < 0
                        ? "text-failed font-semibold"
                        : "text-settled font-semibold"
                      : "text-text-primary font-normal"
                  }`}
                >
                  {item?.owner_account_balance ? (
                    <>
                      {(shouldBeRedacted(item?.owner_account_balance)
                        ? ""
                        : "INR ") +
                        formatTotalBalance(
                          Number(item?.owner_account_balance),
                          currency,
                        )?.amount +
                        " " +
                        formatTotalBalance(
                          Number(item?.owner_account_balance),
                          currency,
                        )?.abbr}
                    </>
                  ) : flow === "internalTxn" ? (
                    "For internal purpose only"
                  ) : (
                    "Not available"
                  )}
                </p>

                <img
                  style={{
                    display:
                      isAssignTagsClicked || isLabelClicked || multiSelect
                        ? "flex"
                        : "none",
                  }}
                  className="w-icon-sm h-icon-sm ml-margin-button-s cursor-pointer"
                  src={
                    isAccountSelected
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                  }
                  alt=""
                />
              </div>
            </div>
            <div className="w-full pl-padding-sm flex justify-between items-center">
              <p className="text-font-xs flex-1 text-text-primary truncate font-normal">
                <TickerAnimation text={item?.name} />
              </p>
              <div
                style={{
                  display: item?.favourite === "Y" ? "flex" : "none",
                }}
                className="gap-x-gap-sm ml-margin-sm justify-end"
              >
                <img
                  className="w-icon-sm h-icon-sm"
                  src={ICONS?.FAVOURITE_FILLED}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            className={`${
              item?.connected_banking === "Y" &&
              !isAssignTagsClicked &&
              !isLabelClicked &&
              !multiSelect
                ? "flex"
                : "hidden"
            } flex-col gap-y-gap-xs`}
          >
            {service && (
              <CardActionableButton
                handleFunction={(e) => {
                  if (
                    !isopen &&
                    !refreshAll &&
                    item?.connected_banking === "Y"
                  ) {
                    if (
                      services.includes("VAccountBalance") ||
                      services?.includes("Admin")
                    ) {
                      e.stopPropagation();
                      setFailedRefreshId([]);
                      setSuccessRefreshId([]);
                      setAccId(item?.id);
                      setPrevId(item?.id);
                      setRefreshtype("single");
                      setPrevBalance(item?.owner_account_balance);
                      setPrev_Total_balance_state(total_balance);
                      handleRefresh(item?.id, true);
                    } else {
                      e.stopPropagation();
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "VAccountBalance,Admin",
                        },
                      });
                    }
                  } else {
                    e.stopPropagation();
                  }
                }}
                icon={ICONS?.RELOAD_REFRESH_WHITE}
                isDisabled={
                  !(
                    services?.includes("VAccountBalance") ||
                    services?.includes("Admin")
                  ) ||
                  ownerAccBalanceLoading ||
                  refreshAll
                }
                title="Refresh balance"
                bgColor="var(--primary-nav)"
              />
            )}
            <CardActionableButton
              handleFunction={(e) => {
                if (typepop === "popup") {
                  return actionRestricted();
                } else if (
                  services?.includes("VAccountBalance") ||
                  services?.includes("Admin")
                ) {
                  if (!isopen && item?.connected_banking === "Y") {
                    e.stopPropagation();
                    setAccData(item);
                    setStatementId(item?.id);
                    handleViewStatement();
                  }
                } else {
                  e.stopPropagation();
                  navigate("/feature_not_assigned", {
                    state: {
                      unavailableService: "VAccountBalance,Admin",
                    },
                  });
                }
              }}
              icon={ICONS?.VIEW_STATEMENT_OUTLINE}
              isDisabled={
                (!services?.includes("VAccountBalance") &&
                  !services?.includes("Admin")) ||
                typepop === "popup"
              }
              title="Bank statement"
              bgColor="var(--primary-nav)"
            />
          </div>
        </div>
      </list-body>
      <list-hover>
        {refreshGifProps && <ListTextWithGif {...refreshGifProps} />}
        <ListDualText
          text1={item?.ifsc_code}
          subtext1={TEXT?.IFSC}
          text2={
            item?.owner_account_balance_last_fetched_at_in_words ||
            "Not applicable"
          }
          subtext2="Balance updated"
        />
        <ListTextWithIcon
          type="text"
          text={
            item?.tags?.length ? item?.tags?.join(", ") : "No tags assigned"
          }
          iconComponentArray={[
            {
              icon: ICONS?.ASSIGN_TAG_WITHOUT_CIRCLE,
            },
          ]}
        />
        <ListTextWithIcon
          type="text"
          text={
            item?.labels?.length
              ? item?.labels?.join(", ")
              : "No labels assigned"
          }
          iconComponentArray={[
            {
              icon: ICONS?.LABEL,
            },
          ]}
        />
      </list-hover>
    </ListContainer>
  );
};

export default OwnerAccountListViewComp;
